const initialState = {
  path: "home",
};

export default initialState;
